// core
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// components
import { PolicyDetailsComponent } from '@open-portal-app/policy/policy-details/policy-details.component';
import { OdoFlowComponent } from './odo-reading/odo-flow/odo-flow.component';
import { PaymentUpdateFlowComponent } from './payment/payment-update-flow/payment-update-flow.component';
import { PaymentRetryFlowComponent } from './payment/payment-retry-flow/payment-retry-flow.component';
import { ClaimTriageComponent } from './claim-triage/claim-triage.component';

// services
import { PolicyResolver } from '@open-portal-app/core/resolvers/policy.resolver';
import { OdoResolver } from '@open-portal-app/core/resolvers/odo.resolver';
import { UpdatePolicyResolver } from '@open-portal-app/core/resolvers/update-policy.resolver';

const routes: Routes = [
  {
    path: 'odo/:uuid',
    component: OdoFlowComponent,
    pathMatch: 'full',
    resolve: { policy: OdoResolver }
  },
  {
    path: 'payment/update/:uuid',
    component: PaymentUpdateFlowComponent,
    pathMatch: 'full',
    resolve: { policy: UpdatePolicyResolver }
  },
  {
    path: 'payment/retry/:uuid',
    component: PaymentRetryFlowComponent,
    pathMatch: 'full',
    resolve: { policy: UpdatePolicyResolver }
  },
  {
    path: ':productClass/:uuid',
    component: PolicyDetailsComponent,
    pathMatch: 'full',
    resolve: { policy: PolicyResolver }
  },
  {
    path: ':productClass/:uuid/claim-triage',
    component: ClaimTriageComponent,
    pathMatch: 'full',
    resolve: { policy: PolicyResolver }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PolicyRoutingModule { }
